import React, { useEffect, useState } from "react";
import iconEdit from "../../../assets/images/iconEdit.png";
import DashboardHeader from "@/components/DashboardHeader";
import SelectInput from "@/components/selectInput/SelectInput";
import { SubmitHandler, useForm } from "react-hook-form";
import { AstericSign, FormHookInput, Loader, Button, emailValidator, namePattern, NON_DIGIT_REGEX } from "@thdinc/hpf-shared";
import userDefaultImg from "../../../assets/images/defaultuser.jpg";
import { useLocation, useNavigate } from "react-router";
import Alert from "@/components/alert/Alert";
import { GET, PATCH_MULTIPART, POST_MULTIPART } from "@/services/api";
import { API_ROUTES } from "@/services/environment";
import { useAppSelector } from "@/hooks/hook";
import {
  ACCEPTED_IMAGE_TYPES,
  genderData,
  MAX_FILE_SIZE_MB,
} from "@/constants/Common";
import useLoading from "@/hooks/useLoading";
import { Input } from "@thdinc/hpf-shared";
import ChangesAlert from "@/components/alert/ChangesAlert";
import useError from "@/hooks/useError ";
import { IoArrowBackCircleOutline } from "react-icons/io5";
import { IoMdArrowBack } from "react-icons/io";
import { BartenderInteface } from "@/interfaces/Bartender";

interface addBartender {
  businessId: string;
  isEdit: boolean;
  btcId?: string;
  refreshBartenderList?: () => void;
}

type Inputs = {
  name: string;
  lastName: string;
  email: string;
  phone: string;
  phone_number: string;
  fee: number;
};
const AddBTCBySuperAdmin: React.FC<addBartender> = ({
  businessId,
  btcId,
  isEdit,
  refreshBartenderList,
}) => {
  const { bartenders, getSingleBartender } = API_ROUTES;
  const { refreshToken } = useAppSelector((store) => store.user);
  const { isLoading, startLoading, stopLoading } = useLoading();
  const [selectedGender, setSelectedGender] = useState<string>("");
  const [selectLang, setSelectLang] = useState<string[]>([]);
  const [error, setCustomError] = useError();

  const location = useLocation();
  const [bartender, setBartender] = useState<BartenderInteface>();

  // const isEdit = location.state?.isEdit;
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm<Inputs>();

  useEffect(() => {
    if (btcId)
      (async () => {
        const res = await GET(
          `${getSingleBartender}/${btcId}?business_id=${businessId}`,
          refreshToken
        );
        console.log("bart", res);
        setValue("name", res?.data?.first_name);
        setValue("lastName", res.data?.last_name);
        setValue("email", res?.data?.email);
        setValue("phone_number", res?.data?.phone_number);
        setSelectLang(res?.data?.languages);
        setBartender(res.data);
        setSelectedGender(res.data.gender);
        setSelectLang(res.data.languages);
      })();
  }, []);
  // const [imageUrl, setImageUrl] = useState<File | null>(null);
  const [profile, setProfile] = useState<File | null>(null);
  // const [isBartender, setIsBartender] = useState<boolean>(false);
  const [errorState, setErrorState] = useState<{
    name: string | null;
    error: string | null;
  }>({ name: "", error: "" });
  //const [selectLocation, setSelectLocation] = useState<string>("Select");
  //const [guests, setGuests] = useState("25-50");
  const navigate = useNavigate();
  // const removeImage = () => {
  //   setImageUrl(null);
  // };
  const [modal, setModal] = useState<boolean>(false);
  const [activeData, setActiveData] = useState<any | null>(null);
  const selectGenderFun = (gender: string) => {
    setSelectedGender(gender);
    if (errorState.name === "gender") {
      setErrorState({ name: null, error: null });
    }
  };

  const selectLangFun = (checked: boolean, lang: string) => {
    if (checked) {
      setSelectLang([...selectLang, lang]);
      setErrorState({ name: null, error: null });
    } else {
      setSelectLang(selectLang.filter((item) => item !== lang));
    }
  };
  // const selectLocationFUn = (location: string) => {
  //   setSelectLocation(location);
  //   if (errorState.name === "location") {
  //     setErrorState({ name: null, error: null });
  //   }
  // };
  const onSubmit: SubmitHandler<Inputs> = async (data) => {
    try {
      // if provided conditions are failed through an error
      if (
        (profile && selectedGender !== "null" && selectLang.length !== 0) ||
        (isEdit && selectedGender !== "null" && selectLang.length !== 0)
      ) {
        startLoading();
        const formData = new FormData();
        formData.append("first_name", data.name);
        formData.append("last_name", data.lastName);
        formData.append("gender", selectedGender);
        formData.append("email", data.email);
        formData.append("phone_number", data.phone_number);
        formData.append("language", JSON.stringify(selectLang));
        if (businessId) {
          // formData.append("isSuperAdmin", isSuperAdmin.toString());
          formData.append("business_id", businessId);
          // formData.append("is_bartender", isBartender.toString());
        }
        //formData.append("location", selectLocation);
        // formData.append("hourly_rate", String(data.fee));
        // formData.append("guest_capacity", guests);
        if (profile) {
          formData.append("avatar", profile);
        }
        // if (imageUrl) {
        //   formData.append("other_photos", imageUrl);
        // }
        setActiveData(formData);
        setModal(true);
      }
      if (!profile && !isEdit) {
        setErrorState({ name: "dp", error: "Please upload profile image" });
      } else if (selectedGender === "null") {
        setErrorState({ name: "gender", error: "Please select a gender" });
      } else if (selectLang.length === 0) {
        setErrorState({ name: "lang", error: "Please select a language" });
      }
    } catch (error) {
      console.log(error);
    } finally {
      stopLoading();
    }
  };
  // const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });
  const handleProfileImg = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      if (ACCEPTED_IMAGE_TYPES.includes(file.type)) {
        if (file.size <= MAX_FILE_SIZE_MB * 1024 * 1024) {
          // Convert MB to bytes
          const fileWithTimestamp = addTimestampToFile(file);
          setProfile(fileWithTimestamp); // Set profile image with timestamped file name
          setErrorState({ name: null, error: null });
        } else {
          // if the image selected with wrong size
          setErrorState({
            name: "dp",
            error: `File size exceeds ${MAX_FILE_SIZE_MB} MB. Please choose a smaller image.`,
          });
        }
      } else {
        // if the image selected with wrong type
        setErrorState({
          name: "dp",
          error:
            "Please select a valid image file (JPEG, PNG, GIF, BMP, or TIFF).",
        });
      }
    }
  };
  function addTimestampToFile(file: File): File {
    // Create a new file object with timestamped name
    const timestamp = Date.now(); // Get current timestamp
    const fileName = `${timestamp}_${file.name}`; // Add timestamp to file name
    return new File([file], fileName, { type: file.type }); // Create a new file object with timestamped name
  }

  const saveDetails = async () => {
    setModal(false);
    startLoading();
    // if edit mode is enabled so patch request will be used other wise post request for new
    try {
      const response = isEdit
        ? await PATCH_MULTIPART(
          bartenders + "/" + bartender?.id,
          activeData,
          refreshToken
        )
        : await POST_MULTIPART(bartenders, activeData, refreshToken);

      if (response.data.success) {
        Alert({ message: response?.data?.message });
        if (refreshBartenderList) {
          refreshBartenderList();
        }
      } else {
        Alert({ type: "error", message: response?.data?.message });
      }
      stopLoading();
    } catch (error) {
      console.log("error", error);
      setCustomError("add", "Something went wrong");
      stopLoading();
      // Handle error
    }
  };
  const goBack = () => {
    navigate(-1);
  };

  return (
    <div>
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="container mx-auto  md:gap-4      "
      >
        {/* left div */}
        <div className="bg-white rounded-2xl border p-6 w-full  flex md:flex-row flex-col items-center gap-5 ">
          <div className="flex flex-col  items-center  ">
            <div className="justify-center relative flex ">
              <img
                className="mt-4 w-56 h-56 object-cover rounded-full  border-primary-red border-2 self-center"
                src={
                  profile
                    ? URL.createObjectURL(profile)
                    : bartender?.avatar
                      ? bartender?.avatar
                      : userDefaultImg
                }
              />
              {/* <div className=" font-semibold my-2">*</div> */}
              <div className="bg-primary-red absolute rounded-full p-2 bottom-0 ml-24  cursor-pointer">
                <label className=" cursor-pointer">
                  <img className="h-3 w-auto" src={iconEdit} />
                  <input
                    accept="image/*"
                    id="profile-img"
                    onChange={handleProfileImg}
                    type="file"
                    className="hidden"
                  />
                </label>
              </div>
            </div>
            <div className="text-center">
              {errorState.name === "dp" && (
                <p className="text-red-500 text-xs mt-1 py-">
                  {errorState.error}
                </p>
              )}
              <p className="text-gray-500 text-xs mt-2 md:w-8/12 mx-auto ">
                Please upload an image in one of the accepted formats: JPEG, PNG
              </p>
            </div>
          </div>
          <div className="flex flex-col items-center justify-center mt-4 w-full">
            <div className="flex gap-4 flex-col md:flex-row w-full  ">
              <div className="w-full ">
                <div className=" font-semibold my-2">First Name <AstericSign /></div>
                <FormHookInput
                  type="text"
                  placeholder="First Name"
                  register={register("name", {
                    required: "First Name is required",
                    maxLength: {
                      value: 50,
                      message:
                        "First Name length can't be more than 50 characters.",
                    },
                    pattern: {
                      value: namePattern, // allow letters, hyphens, and apostrophes, between 1 and 50 characters
                      message: "Invalid first name format",
                    },
                  })}
                  error={errors.name}
                />
              </div>
              <div className="w-full ">
                <div className=" font-semibold my-2">Last Name <AstericSign /></div>
                <FormHookInput
                  type="text"
                  placeholder="Last Name"
                  register={register("lastName", {
                    required: "Last First Name is required",
                    maxLength: {
                      value: 50,
                      message:
                        "Last Name length can't be more than 50 characters.",
                    },

                    pattern: {
                      value: namePattern, // allow letters, hyphens, and apostrophes, between 1 and 50 characters
                      message: "Invalid Last Name format",
                    },
                  })}
                  error={errors.lastName}
                />
              </div>
            </div>
            <div className="flex gap-4 w-full flex-col md:flex-row">
              <div className="w-full ">
                <div className=" font-semibold my-2">Email <AstericSign /></div>
                <FormHookInput
                  type="email"
                  placeholder="Email"
                  register={register("email", {
                    required: "Email is required!",
                    pattern: emailValidator,
                  })}
                  error={errors.email}
                />
              </div>
              <div className="w-full ">
                <div className=" font-semibold my-2">Phone <AstericSign /></div>
                {/* <PhoneInput
                  value={phone}
                  placeholder="+1 999 999 9999"
                  onChange={(e) => setPhone(e.target.value)}
                  mask="+1 999 999 9999"
                /> */}
                <FormHookInput
                  type="text"
                  placeholder="Phone Number"
                  register={register("phone_number", {
                    required: false,
                    validate: (value) => {
                      if (!value) return true;
                      const tel = (value as string).replace(
                        NON_DIGIT_REGEX,
                        ""
                      );
                      if (/^1?\d{10}$/.test(tel)) return true;
                      return "Please enter a valid phone number.";
                    },
                  })}
                  error={errors.phone_number}
                />
              </div>
            </div>
            <div className="flex gap-4 w-full flex-col md:flex-row">
              <div className="w-full ">
                <div className=" font-semibold my-2 ">Gender <AstericSign /></div>
                <SelectInput
                  disabled={false}
                  options={genderData}
                  value={selectedGender}
                  onChange={selectGenderFun}

                />
                {errorState.name === "gender" && (
                  <p className="text-red-500 text-xs mt-1 py-">
                    {errorState.error}
                  </p>
                )}
              </div>

              <div className="w-full ">
                <div className=" font-semibold my-2">Language <AstericSign /></div>
                <div className="flex justify-start mt-2 gap-5">
                  <div className={`flex items-center gap-2 ${selectLang.includes("en") && "bg-[#ffeee5] "
                    } px-3 py-2 rounded-full`}>
                    <p>English</p>
                    <Input
                      onChange={(e) => selectLangFun(e.target.checked, "en")}
                      className="cursor-pointer appearance-none h-5 w-5 border border-gray-300 rounded-full checked:bg-primary-red checked:border-transparent focus:outline-none"
                      type="checkbox"
                      checked={selectLang.includes("en")}
                    />
                  </div>
                  <div className={`flex items-center gap-2  ${selectLang.includes("es") && "bg-[#ffeee5] "
                    } px-3 py-2 rounded-full`}>
                    <p>Spanish</p>
                    <Input
                      onChange={(e) => selectLangFun(e.target.checked, "es")}
                      checked={selectLang.includes("es")}
                      className="cursor-pointer appearance-none h-5 w-5 border border-gray-300 rounded-full checked:bg-primary-red checked:border-transparent focus:outline-none"
                      type="checkbox"
                    />
                  </div>
                </div>
                {errorState.name === "lang" && (
                  <p className="text-red-500 text-xs mt-1 py-">
                    {errorState.error}
                  </p>
                )}
              </div>
            </div>
            {/* <div className="w-full mt-2">
              <div className="flex items-center gap-2">
                <p>Is Bartender</p>
                <Input
                  onChange={(e) => setIsBartender(e.target.checked)}
                  checked={isBartender}
                  className="w-4 h-4 cursor-pointer accent-primary-red"
                  type="checkbox"
                />
              </div>
            </div> */}
            <div className="flex justify-end mt-5 w-full gap-4">
              <Button
                classes="bg-primary-red text-white hover:bg-primary-red-button-hover "
                type="submit"
                disabled={isLoading}
              >
                {" "}
                {isLoading ? <Loader color="bg-gray-50"/> : "Save"}
              </Button>
            </div>
            {error?.name === "add" && (
              <p className="text-primary-red text-center mt-">
                {error.message}
              </p>
            )}
          </div>
        </div>

        {/* right div */}
        {/* <div className="bg-white rounded-2xl border p-6  md:w-5/12 md:mt-0 mt-5">
          <h3 className="font-popins text-xl font-bold">Bartender Fee *</h3>

          <div className="flex flex-col lg:flex-row  justify-between border-b-2 mt-2 py-5">
            <p className=" font-semibold my-2">Hourly Rate *</p>
            <div className="lg:w-6/12 flex items-center gap-2">
              <p className="font-semibold">$</p>
              <div>

              <FormHookInput
                classes=""
                type="number"
                placeholder="10-1000"
                register={register("fee", {
                  required: "Fee is required!",
                  max: {
                    value: 100,
                    message: "This Price can't be more than 500.",
                  },
                  min: {
                    value: 10,
                    message: "This Price can't be less than 10.",
                  },
                })}
                error={errors?.fee}
                />
                </div>
            </div>
          </div>

          <h3 className="font-popins text-xl font-bold mt-4 ">Other Photos</h3>
          <div className="flex border-b-2 mt-4">
            <Dropzone
              image={imageUrl ? URL.createObjectURL(imageUrl) : ""}
              removeImage={removeImage}
              onDrop={(acceptedFiles: any) => {
                const file = addTimestampToFile(acceptedFiles[0]);
                setImageUrl(file)
              }}
            ></Dropzone>
          </div>
          <div className="flex flex-col  gap-2 lg:flex-row justify-between mt-2 border-b-2 md:py-5 py-2">
            <p className="font-semibold my-2">Guest Capacity *</p>
            <div className=" w-full lg:w-6/12">
              <SelectInput
                disabled={false}
                options={[
                  { value: "25-50", label: "25-50" },
                  { value: "50-75", label: "50-75" },
                  { value: "75-100", label: "75-100" },
                ]}
                value={guests}
                onChange={(selectedValue: string) => {
                  setGuests(selectedValue);
                }}
              />
            </div>
          </div>
          <div className="flex justify-end mt-4 ">
            <div className="flex justify-end">
              <Button disabled={loading} > {loading ? "Loading.." : "Save"}</Button>
            </div>
          </div>
        </div> */}
      </form>
      <ChangesAlert
        title={"Save Changes"}
        desc={`Are you sure you want to save this changes?`}
        positiveButtonText={"Yes"}
        negativeButtonText={"Cancel"}
        handleDiscardChanges={() => {
          setModal(false);
        }}
        handleSaveChanges={saveDetails}
        isOpen={modal}
      />
    </div>
  );
};

export default AddBTCBySuperAdmin;
